import React, { useState, useEffect } from 'react';
import { styles, colors, radius } from '../../styles/theme';
import { useToast } from '../../components/Toast';
import { hrTabBar, hrTabBtn, hrInput, hrLabel } from './hrStyles';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

// Ciro payı pozisyon kodları — Task 1 seed'inden
const POZISYON_OPTIONS = [
  { kod: '', ad: '(Seçiniz)' },
  { kod: 'SERVIS_SEF', ad: 'Şef (Servis)' },
  { kod: 'SERVIS_KASA', ad: 'Kasa' },
  { kod: 'SERVIS_GARSON', ad: 'Garson' },
  { kod: 'SERVIS_KOMI', ad: 'Komi' },
  { kod: 'SERVIS_AMOR', ad: 'Amortisman (Servis)' },
  { kod: 'MUTFAK_SEF', ad: 'Mutfak Şef' },
  { kod: 'MUTFAK_ANA', ad: 'Mutfak Ana' },
  { kod: 'MUTFAK_ORTA', ad: 'Mutfak Orta' },
  { kod: 'MUTFAK_BULASIK', ad: 'Bulaşık' },
  { kod: 'MUTFAK_AMOR', ad: 'Amortisman (Mutfak)' },
];

const emptyForm = {
  ad_soyad: '',
  tc_kimlik: '',
  iban: '',
  telefon: '',
  email: '',
  ise_giris_tarihi: new Date().toISOString().split('T')[0],
  ise_cikis_tarihi: '',
  lokasyon_id: '',
  tip: 'KADRO',
  pozisyon: '',
  pozisyon_kodu: '',
  varsayilan_brut_maas: '',
  gunluk_yol_ucreti: '',
  varsayilan_resmi_odeme: '',
  notlar: '',
  dogum_tarihi: '',
  // γ1 — İK v2 yeni alanlar
  adres: '',
  sgk_meslek_kodu: '',
  ogrenim_durumu: '',
  ingilizce_seviyesi: '',
  askerlik_durumu: '',
  ozel_saglik_sigortasi: false,
  acil_iletisim_ad: '',
  acil_iletisim_tel: '',
  acil_iletisim_yakinlik: '',
};

const TABS = [
  { key: 'temel', label: 'Temel Bilgiler' },
  { key: 'belgeler', label: 'Belgeler' },
  { key: 'deneme', label: 'Deneme Süresi' },
  { key: 'maas', label: 'Maaş & Zam' },
  { key: 'izinler', label: 'İzinler' },
  { key: 'disiplin', label: 'Disiplin' },
  { key: 'kidem', label: 'Kıdem Özeti' },
];

const DISIPLIN_TIP_OPTIONS = [
  { v: 'UYARI', l: 'Uyarı' },
  { v: 'KINAMA', l: 'Kınama' },
  { v: 'UCRET_KESINTISI', l: 'Ücret Kesintisi' },
  { v: 'IHRAC', l: 'İhraç' },
];
const DISIPLIN_TIP_LABELS = Object.fromEntries(DISIPLIN_TIP_OPTIONS.map(o => [o.v, o.l]));

const IZIN_TIP_LABELS = {
  YILLIK: 'Yıllık',
  MAZERET: 'Mazeret',
  RAPOR: 'Rapor',
  UCRETSIZ: 'Ücretsiz',
};

const MAAS_NEDEN_OPTIONS = [
  { v: 'YILLIK_ZAM', l: 'Yıllık Zam' },
  { v: 'PERFORMANS', l: 'Performans' },
  { v: 'POZISYON_DEGISIKLIGI', l: 'Pozisyon Değişikliği' },
  { v: 'ASGARI_UCRET', l: 'Asgari Ücret' },
  { v: 'DIGER', l: 'Diğer' },
];
const MAAS_NEDEN_LABELS = Object.fromEntries(MAAS_NEDEN_OPTIONS.map(o => [o.v, o.l]));

const fmtTutar = (v) =>
  Number(v || 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 });

const OGRENIM_OPTIONS = [
  { v: '', l: '(Seçiniz)' },
  { v: 'ILKOGRETIM', l: 'İlköğretim' },
  { v: 'LISE', l: 'Lise' },
  { v: 'ONLISANS', l: 'Ön Lisans' },
  { v: 'UNIVERSITE', l: 'Üniversite' },
  { v: 'YUKSEK_LISANS', l: 'Yüksek Lisans' },
];

const INGILIZCE_OPTIONS = [
  { v: '', l: '(Seçiniz)' },
  { v: 'YOK', l: 'Yok' },
  { v: 'AZ', l: 'Az' },
  { v: 'ORTA', l: 'Orta' },
  { v: 'IYI', l: 'İyi' },
  { v: 'ILERI', l: 'İleri' },
];

const ASKERLIK_OPTIONS = [
  { v: '', l: '(Seçiniz)' },
  { v: 'YAPTI', l: 'Yaptı' },
  { v: 'TECILLI', l: 'Tecilli' },
  { v: 'MUAF', l: 'Muaf' },
  { v: 'BAYAN', l: 'Bayan (askerlik yok)' },
];

const YAKINLIK_OPTIONS = [
  { v: '', l: '(Seçiniz)' },
  { v: 'ES', l: 'Eş' },
  { v: 'ANNE', l: 'Anne' },
  { v: 'BABA', l: 'Baba' },
  { v: 'KARDES', l: 'Kardeş' },
  { v: 'COCUK', l: 'Çocuk' },
  { v: 'ARKADAS', l: 'Arkadaş' },
  { v: 'DIGER', l: 'Diğer' },
];

// γ1 — Yaş hesapla (doğum tarihi → int | null)
const hesaplaYas = (dogum) => {
  if (!dogum) return null;
  const d = new Date(dogum);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let yas = now.getFullYear() - d.getFullYear();
  if (
    now.getMonth() < d.getMonth() ||
    (now.getMonth() === d.getMonth() && now.getDate() < d.getDate())
  ) {
    yas -= 1;
  }
  return yas >= 0 ? yas : null;
};

const PersonelModal = ({ personel, lokasyonlar, onClose, onSaved }) => {
  const toast = useToast();
  const editing = !!personel;
  const [activeTab, setActiveTab] = useState('temel');
  const [form, setForm] = useState(() => {
    if (!personel) return emptyForm;
    return {
      ad_soyad: personel.ad_soyad || '',
      tc_kimlik: personel.tc_kimlik || '',
      iban: personel.iban || '',
      telefon: personel.telefon || '',
      email: personel.email || '',
      ise_giris_tarihi: personel.ise_giris_tarihi || '',
      ise_cikis_tarihi: personel.ise_cikis_tarihi || '',
      lokasyon_id: personel.lokasyon_id || '',
      tip: personel.tip || 'KADRO',
      pozisyon: personel.pozisyon || '',
      pozisyon_kodu: personel.pozisyon_kodu || '',
      varsayilan_brut_maas: personel.varsayilan_brut_maas || '',
      gunluk_yol_ucreti: personel.gunluk_yol_ucreti || '',
      varsayilan_resmi_odeme: personel.varsayilan_resmi_odeme || '',
      notlar: personel.notlar || '',
      dogum_tarihi: personel.dogum_tarihi || '',
      // γ1 — İK v2 yeni alanlar
      adres: personel.adres || '',
      sgk_meslek_kodu: personel.sgk_meslek_kodu || '',
      ogrenim_durumu: personel.ogrenim_durumu || '',
      ingilizce_seviyesi: personel.ingilizce_seviyesi || '',
      askerlik_durumu: personel.askerlik_durumu || '',
      ozel_saglik_sigortasi: !!personel.ozel_saglik_sigortasi,
      acil_iletisim_ad: personel.acil_iletisim_ad || '',
      acil_iletisim_tel: personel.acil_iletisim_tel || '',
      acil_iletisim_yakinlik: personel.acil_iletisim_yakinlik || '',
    };
  });
  const [saving, setSaving] = useState(false);
  // Default: Altı Üstü (id=4). Fetch başarılıysa override, fail-safe için default kalır.
  const [ciroAktifLokIds, setCiroAktifLokIds] = useState([4]);
  // Faz D: ciro payı global bayrağı askıda olabilir → pozisyon kodu alanı hiç görünmez. Bilinene kadar gizle.
  const [ciroPayiAktif, setCiroPayiAktif] = useState(false);

  // Belgeler tab state (B5)
  const [belgeler, setBelgeler] = useState([]);          // [{belge_turu_id, belge_turu_kod, ...}]
  const [belgeDirty, setBelgeDirty] = useState({});      // { [turu_id]: true }
  const [belgeLoading, setBelgeLoading] = useState(false);
  const [belgeSaving, setBelgeSaving] = useState(false);

  // Deneme Süresi tab state (C3)
  const [denemeSonucu, setDenemeSonucu] = useState(personel?.deneme_sonucu || 'DEGERLENDIRILMEDI');
  const [denemeNotu, setDenemeNotu] = useState(personel?.deneme_notu || '');
  const [denemeSaving, setDenemeSaving] = useState(false);

  // γ2 — Maaş & Zam tab state
  const [maasGecmisi, setMaasGecmisi] = useState([]);
  const [maasLoading, setMaasLoading] = useState(false);
  const [maasFormOpen, setMaasFormOpen] = useState(false);
  const [maasSaving, setMaasSaving] = useState(false);
  const [maasForm, setMaasForm] = useState({
    yeni_brut_maas: '',
    yeni_yol_yardimi: '',
    yuzde: '',
    neden: 'YILLIK_ZAM',
    tarih: new Date().toISOString().split('T')[0],
    notlar: '',
  });

  // γ3 — İzinler tab state
  const [izinOzeti, setIzinOzeti] = useState(null);
  const [izinLoading, setIzinLoading] = useState(false);

  // γ6 — Yeniden işe al akışı
  const [yenidenFormOpen, setYenidenFormOpen] = useState(false);
  const [yenidenTarih, setYenidenTarih] = useState('');
  const [yenidenSaving, setYenidenSaving] = useState(false);

  // γ4 — Disiplin tab state
  const [disiplinKayitlari, setDisiplinKayitlari] = useState([]);
  const [disiplinLoading, setDisiplinLoading] = useState(false);
  const [disiplinFormOpen, setDisiplinFormOpen] = useState(false);
  const [disiplinSaving, setDisiplinSaving] = useState(false);
  const [disiplinForm, setDisiplinForm] = useState({
    tarih: new Date().toISOString().split('T')[0],
    tip: 'UYARI',
    aciklama: '',
  });

  // Kıdem Özeti tab state (D4)
  const [kidemTahmin, setKidemTahmin] = useState(null);
  const [kidemLoading, setKidemLoading] = useState(false);
  const [cikisFormOpen, setCikisFormOpen] = useState(false);
  const [cikisForm, setCikisForm] = useState({
    cikis_tarihi: new Date().toISOString().split('T')[0],
    cikis_sebebi: 'ISVEREN_FESHI',
    notlar: '',
  });
  const [cikisSaving, setCikisSaving] = useState(false);

  const token = localStorage.getItem('access_token');

  // Ciro payı aktif lokasyon listesini + global bayrağı yükle
  useEffect(() => {
    fetch(`${API_URL}/api/ik/ayarlar`, { headers: { 'Authorization': `Bearer ${token}` } })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d && d.ciro_payi && Array.isArray(d.ciro_payi.aktif_lokasyon_ids)) {
          setCiroAktifLokIds(d.ciro_payi.aktif_lokasyon_ids);
        }
        if (d) setCiroPayiAktif(!!d.ciro_payi_aktif);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const lokIdNum = form.lokasyon_id ? parseInt(form.lokasyon_id, 10) : null;
  // Faz D: global bayrak kapalıysa ciro payı pozisyon kodu alanı hiç görünmez
  const pozisyonKoduGorunsun = ciroPayiAktif && lokIdNum && ciroAktifLokIds.includes(lokIdNum);

  // Lokasyon ciro-payı dışına çekilirse pozisyon_kodu'yu temizle
  useEffect(() => {
    if (!pozisyonKoduGorunsun && form.pozisyon_kodu) {
      setForm(f => ({ ...f, pozisyon_kodu: '' }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pozisyonKoduGorunsun]);

  // Belgeler yükleme — tab açıldığında, düzenleme modunda
  const loadBelgeler = async () => {
    if (!editing || !personel?.id) return;
    setBelgeLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/belgeler`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        setBelgeler(await r.json());
        setBelgeDirty({});
      } else {
        toast.error('Belgeler yüklenemedi');
      }
    } catch {
      toast.error('Bağlantı hatası (belgeler)');
    } finally {
      setBelgeLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'belgeler' && editing && belgeler.length === 0) {
      loadBelgeler();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // γ3 — İzin özeti yükleme
  const loadIzinOzeti = async () => {
    if (!editing || !personel?.id) return;
    setIzinLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/izin-ozeti`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        setIzinOzeti(await r.json());
      } else {
        toast.error('İzin özeti yüklenemedi');
      }
    } catch {
      toast.error('Bağlantı hatası (izin)');
    } finally {
      setIzinLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'izinler' && editing && !izinOzeti && !izinLoading) {
      loadIzinOzeti();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // γ4 — Disiplin kayıtları yükleme
  const loadDisiplinKayitlari = async () => {
    if (!editing || !personel?.id) return;
    setDisiplinLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/disiplin`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        setDisiplinKayitlari(await r.json());
      } else {
        toast.error('Disiplin kayıtları yüklenemedi');
      }
    } catch {
      toast.error('Bağlantı hatası (disiplin)');
    } finally {
      setDisiplinLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'disiplin' && editing && disiplinKayitlari.length === 0 && !disiplinLoading) {
      loadDisiplinKayitlari();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const handleDisiplinKaydet = async () => {
    if (!disiplinForm.aciklama.trim()) {
      toast.warning('Açıklama zorunlu');
      return;
    }
    if (!disiplinForm.tarih) {
      toast.warning('Tarih zorunlu');
      return;
    }
    setDisiplinSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/disiplin`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          tarih: disiplinForm.tarih,
          tip: disiplinForm.tip,
          aciklama: disiplinForm.aciklama,
        }),
      });
      if (r.ok) {
        toast.success('Disiplin kaydı oluşturuldu');
        setDisiplinFormOpen(false);
        setDisiplinForm({
          tarih: new Date().toISOString().split('T')[0],
          tip: 'UYARI',
          aciklama: '',
        });
        await loadDisiplinKayitlari();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Kayıt oluşturulamadı');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setDisiplinSaving(false);
    }
  };

  const handleDisiplinSil = async (kayit) => {
    if (!window.confirm(
      `"${DISIPLIN_TIP_LABELS[kayit.tip] || kayit.tip}" kaydı silinsin mi?\n\n` +
      `Sadece aynı gün oluşturulan kayıtlar silinebilir (audit log kuralı).`
    )) return;

    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/disiplin/${kayit.id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        toast.success('Kayıt silindi');
        await loadDisiplinKayitlari();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Silinemedi');
      }
    } catch {
      toast.error('Bağlantı hatası');
    }
  };

  // γ2 — Maaş geçmişi yükleme
  const loadMaasGecmisi = async () => {
    if (!editing || !personel?.id) return;
    setMaasLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/maas-gecmisi`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        setMaasGecmisi(await r.json());
      } else {
        toast.error('Maaş geçmişi yüklenemedi');
      }
    } catch {
      toast.error('Bağlantı hatası (maaş)');
    } finally {
      setMaasLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'maas' && editing && maasGecmisi.length === 0 && !maasLoading) {
      loadMaasGecmisi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // γ2 — Maaş geçmişi kaydı sil
  const handleMaasSil = async (kayit) => {
    if (!kayit?.id || !personel?.id) return;

    const onay = window.confirm(
      `${kayit.tarih} tarihli ${fmtTutar(kayit.yeni_brut_maas)} ₺ maaş kaydı silinsin mi?\n\n` +
      'Personelin mevcut maaşı kalan son geçerli maaş kaydına döndürülecektir.'
    );
    if (!onay) return;

    setMaasSaving(true);
    try {
      const r = await fetch(
        `${API_URL}/api/hr/personel/${personel.id}/maas-gecmisi/${kayit.id}`,
        {
          method: 'DELETE',
          headers: { 'Authorization': `Bearer ${token}` },
        }
      );

      if (r.ok) {
        const sonuc = await r.json().catch(() => ({}));
        toast.success('Maaş kaydı silindi');

        if (sonuc.guncel_brut_maas != null) {
          setForm(f => ({
            ...f,
            varsayilan_brut_maas: sonuc.guncel_brut_maas,
          }));
        }

        await loadMaasGecmisi();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Maaş kaydı silinemedi');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setMaasSaving(false);
    }
  };

  // γ2 — Zam kaydı oluştur
  const handleMaasKaydet = async () => {
    const yeniBrut = parseFloat(maasForm.yeni_brut_maas);
    if (!yeniBrut || yeniBrut <= 0) {
      toast.warning('Geçerli bir brüt maaş giriniz');
      return;
    }
    if (!maasForm.tarih) {
      toast.warning('Tarih zorunlu');
      return;
    }
    setMaasSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/maas-gecmisi`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          yeni_brut_maas: yeniBrut,
          yeni_yol_yardimi: parseFloat(maasForm.yeni_yol_yardimi) || 0,
          neden: maasForm.neden,
          tarih: maasForm.tarih,
          notlar: maasForm.notlar || null,
        }),
      });
      if (r.ok) {
        toast.success('Zam kaydı oluşturuldu');
        // Mevcut brüt görüntülemesini güncelle — form state'i de güncelle.
        // maas-gecmisi backend'i hâlâ aylık yol (yeni_yol_yardimi) ile çalışıyor;
        // günlük ücret bu akıştan değişmez (ana formdan yönetilir).
        setForm(f => ({
          ...f,
          varsayilan_brut_maas: yeniBrut,
        }));
        setMaasFormOpen(false);
        setMaasForm({
          yeni_brut_maas: '',
          yeni_yol_yardimi: '',
          yuzde: '',
          neden: 'YILLIK_ZAM',
          tarih: new Date().toISOString().split('T')[0],
          notlar: '',
        });
        await loadMaasGecmisi();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Zam kaydı oluşturulamadı');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setMaasSaving(false);
    }
  };

  // γ2 — Yüzde <-> brüt iki yönlü hesaplama
  const handleYuzdeChange = (e) => {
    const yuzde = e.target.value;
    const eskiBrut = parseFloat(form.varsayilan_brut_maas) || 0;
    const y = parseFloat(yuzde);
    let yeniBrut = maasForm.yeni_brut_maas;
    if (!isNaN(y) && eskiBrut > 0) {
      yeniBrut = (eskiBrut * (1 + y / 100)).toFixed(2);
    }
    setMaasForm(f => ({ ...f, yuzde, yeni_brut_maas: yeniBrut }));
  };

  const handleYeniBrutChange = (e) => {
    const yeniBrut = e.target.value;
    const eskiBrut = parseFloat(form.varsayilan_brut_maas) || 0;
    const yb = parseFloat(yeniBrut);
    let yuzde = maasForm.yuzde;
    if (!isNaN(yb) && eskiBrut > 0) {
      yuzde = (((yb - eskiBrut) / eskiBrut) * 100).toFixed(2);
    }
    setMaasForm(f => ({ ...f, yeni_brut_maas: yeniBrut, yuzde }));
  };

  const updateBelgeRow = (turu_id, patch) => {
    setBelgeler(prev => prev.map(b =>
      b.belge_turu_id === turu_id ? { ...b, ...patch } : b
    ));
    setBelgeDirty(prev => ({ ...prev, [turu_id]: true }));
  };

  const handleBelgeKaydet = async () => {
    if (!editing || !personel?.id) return;
    const dirtyIds = Object.keys(belgeDirty).filter(k => belgeDirty[k]);
    if (dirtyIds.length === 0) {
      toast.info('Değişiklik yok');
      return;
    }
    setBelgeSaving(true);
    let basarili = 0;
    let hata = 0;
    for (const idStr of dirtyIds) {
      const turu_id = parseInt(idStr, 10);
      const row = belgeler.find(b => b.belge_turu_id === turu_id);
      if (!row) continue;
      const body = {
        alindi: !!row.alindi,
        alinma_tarihi: row.alinma_tarihi || null,
        son_gecerlilik_tarihi: row.son_gecerlilik_tarihi || null,
        notlar: row.notlar || null,
      };
      try {
        const r = await fetch(
          `${API_URL}/api/hr/personel/${personel.id}/belgeler/${turu_id}`,
          {
            method: 'PUT',
            headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          }
        );
        if (r.ok) basarili++;
        else hata++;
      } catch {
        hata++;
      }
    }
    setBelgeSaving(false);
    if (hata === 0) {
      toast.success(`${basarili} belge güncellendi`);
      await loadBelgeler();
    } else {
      toast.error(`${basarili} başarılı, ${hata} hata`);
    }
  };

  // C3: Deneme süresi kaydet
  const handleDenemeKaydet = async () => {
    if (!editing || !personel?.id) return;
    setDenemeSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/deneme`, {
        method: 'PATCH',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          deneme_sonucu: denemeSonucu,
          deneme_notu: denemeNotu || null,
        }),
      });
      if (r.ok) {
        const data = await r.json();
        const kapatilan = data.guncellenen_bildirim_sayisi || 0;
        toast.success(
          kapatilan > 0
            ? `Deneme durumu güncellendi (${kapatilan} bildirim kapatıldı)`
            : 'Deneme durumu güncellendi'
        );
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setDenemeSaving(false);
    }
  };

  // γ6 — Yeniden işe al
  const handleYenidenIseAl = async () => {
    if (!editing || !personel?.id) return;
    setYenidenSaving(true);
    try {
      const body = {};
      if (yenidenTarih) body.yeni_ise_giris_tarihi = yenidenTarih;
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/yeniden-ise-al`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      if (r.ok) {
        toast.success('Personel yeniden işe alındı');
        setYenidenFormOpen(false);
        setYenidenTarih('');
        onSaved();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'İşlem başarısız');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setYenidenSaving(false);
    }
  };

  const handleSave = async () => {
    if (!form.ad_soyad.trim()) { toast.warning('Ad soyad zorunlu'); return; }
    if (!form.ise_giris_tarihi) { toast.warning('İşe giriş tarihi zorunlu'); return; }

    setSaving(true);
    try {
      const payload = {
        ...form,
        lokasyon_id: form.lokasyon_id ? parseInt(form.lokasyon_id, 10) : null,
        varsayilan_brut_maas: parseFloat(form.varsayilan_brut_maas) || 0,
        gunluk_yol_ucreti: parseFloat(form.gunluk_yol_ucreti) || 0,
        varsayilan_resmi_odeme: parseFloat(form.varsayilan_resmi_odeme) || 0,
        ise_cikis_tarihi: form.ise_cikis_tarihi || null,
        dogum_tarihi: form.dogum_tarihi || null,
        ozel_saglik_sigortasi: !!form.ozel_saglik_sigortasi,
      };
      // Remove empty-string optional fields (boolean false korunur)
      Object.keys(payload).forEach(k => {
        if (payload[k] === '') payload[k] = null;
      });

      const baseUrl = editing ? `${API_URL}/api/personel/${personel.id}` : `${API_URL}/api/personel`;
      const method = editing ? 'PUT' : 'POST';
      let r = await fetch(baseUrl, {
        method,
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      // TC duplicate → onay iste, force_duplicate=true ile tekrar dene
      if (!editing && r.status === 409) {
        const err = await r.json().catch(() => ({}));
        if (window.confirm(`${err.detail}\n\nAynı kişiyi farklı lokasyonda kaydetmek için 'Tamam'a basın.`)) {
          r = await fetch(`${baseUrl}?force_duplicate=true`, {
            method, headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });
        } else {
          setSaving(false); return;
        }
      }

      if (r.ok) {
        toast.success(editing ? 'Güncellendi' : 'Eklendi');
        onSaved();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Hata oluştu');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle = { width: '100%', padding: '8px 10px', border: `1px solid ${colors.border}`, borderRadius: radius.sm, fontSize: 13, boxSizing: 'border-box' };
  const labelStyle = { display: 'block', fontSize: 11, color: colors.textSecondary, fontWeight: 600, marginBottom: 4, marginTop: 10 };

  // γ1 — Temel Bilgiler 5 alt bölüme ayrıldı
  const sectionStyle = {
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    padding: 12,
    marginBottom: 12,
    background: '#fafbfc',
  };
  const sectionTitle = {
    fontSize: 11,
    fontWeight: 700,
    color: '#1e40af',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: 10,
  };

  const renderTemelBilgiler = () => {
    const yas = hesaplaYas(form.dogum_tarihi);
    return (
      <div>
        {/* Ad Soyad — bölümsüz üstte tek başına */}
        <div style={{ marginBottom: 12 }}>
          <label style={labelStyle}>Ad Soyad *</label>
          <input style={inputStyle} value={form.ad_soyad} onChange={e => setForm({ ...form, ad_soyad: e.target.value })} />
        </div>

        {/* 1. Kişisel */}
        <div style={sectionStyle}>
          <div style={sectionTitle}>Kişisel</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label style={labelStyle}>TC Kimlik</label>
              <input style={inputStyle} value={form.tc_kimlik} onChange={e => setForm({ ...form, tc_kimlik: e.target.value })} maxLength={11} />
            </div>
            <div>
              <label style={labelStyle}>
                Doğum Tarihi
                {yas !== null && (
                  <span style={{ marginLeft: 6, color: '#1565c0', fontWeight: 700 }}>
                    (Yaş: {yas})
                  </span>
                )}
              </label>
              <input style={inputStyle} type="date" value={form.dogum_tarihi} onChange={e => setForm({ ...form, dogum_tarihi: e.target.value })} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>Adres</label>
              <textarea
                style={{ ...inputStyle, minHeight: 50, fontFamily: 'inherit' }}
                value={form.adres}
                onChange={e => setForm({ ...form, adres: e.target.value })}
              />
            </div>
          </div>
        </div>

        {/* 2. İletişim */}
        <div style={sectionStyle}>
          <div style={sectionTitle}>İletişim</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label style={labelStyle}>Telefon</label>
              <input style={inputStyle} value={form.telefon} onChange={e => setForm({ ...form, telefon: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Email</label>
              <input style={inputStyle} type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
            </div>
            <div style={{ gridColumn: '1 / -1' }}>
              <label style={labelStyle}>IBAN</label>
              <input style={inputStyle} value={form.iban} onChange={e => setForm({ ...form, iban: e.target.value })} maxLength={32} />
            </div>
          </div>
        </div>

        {/* 3. Acil Durum */}
        <div style={sectionStyle}>
          <div style={sectionTitle}>Acil Durum İletişim</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10 }}>
            <div>
              <label style={labelStyle}>Ad Soyad</label>
              <input
                style={inputStyle}
                value={form.acil_iletisim_ad}
                onChange={e => setForm({ ...form, acil_iletisim_ad: e.target.value })}
              />
            </div>
            <div>
              <label style={labelStyle}>Telefon</label>
              <input
                style={inputStyle}
                value={form.acil_iletisim_tel}
                onChange={e => setForm({ ...form, acil_iletisim_tel: e.target.value })}
              />
            </div>
            <div>
              <label style={labelStyle}>Yakınlık</label>
              <select
                style={inputStyle}
                value={form.acil_iletisim_yakinlik}
                onChange={e => setForm({ ...form, acil_iletisim_yakinlik: e.target.value })}
              >
                {YAKINLIK_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
          </div>
        </div>

        {/* 4. Çalışma Bilgileri */}
        <div style={sectionStyle}>
          <div style={sectionTitle}>Çalışma Bilgileri</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label style={labelStyle}>İşe Giriş Tarihi *</label>
              <input style={inputStyle} type="date" value={form.ise_giris_tarihi} onChange={e => setForm({ ...form, ise_giris_tarihi: e.target.value })} />
            </div>
            <div>
              <label style={labelStyle}>Lokasyon</label>
              <select style={inputStyle} value={form.lokasyon_id} onChange={e => setForm({ ...form, lokasyon_id: e.target.value })}>
                <option value="">(Seçiniz)</option>
                {lokasyonlar.map(l => <option key={l.id} value={l.id}>{l.ad}</option>)}
              </select>
            </div>

            <div>
              <label style={labelStyle}>Tip</label>
              <select style={inputStyle} value={form.tip} onChange={e => setForm({ ...form, tip: e.target.value })}>
                <option value="KADRO">Kadro</option>
                <option value="SERBEST">Serbest</option>
                <option value="PART_TIME">Part Time</option>
                <option value="EMEKLI">Emekli</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>SGK Meslek Kodu</label>
              <input
                style={inputStyle}
                placeholder="ör. 7511.01"
                value={form.sgk_meslek_kodu}
                onChange={e => setForm({ ...form, sgk_meslek_kodu: e.target.value })}
              />
            </div>

            <div style={{ gridColumn: pozisyonKoduGorunsun ? 'auto' : '1 / -1' }}>
              <label style={labelStyle}>Pozisyon</label>
              <input style={inputStyle} placeholder="ör. Garson, Komi, Muhasebeci, Müdür, Usta" value={form.pozisyon} onChange={e => setForm({ ...form, pozisyon: e.target.value })} />
            </div>
            {pozisyonKoduGorunsun && (
              <div>
                <label style={labelStyle}>Ciro Payı Pozisyon Kodu *</label>
                <select style={inputStyle} value={form.pozisyon_kodu} onChange={e => setForm({ ...form, pozisyon_kodu: e.target.value })}>
                  {POZISYON_OPTIONS.map(p => <option key={p.kod} value={p.kod}>{p.ad}</option>)}
                </select>
                <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>Sadece ciro payı aktif lokasyonlarda (Altı Üstü).</div>
              </div>
            )}

            <div>
              <label style={labelStyle}>Aylık Net Maaş (₺)</label>
              <input style={inputStyle} type="number" step="0.01" value={form.varsayilan_brut_maas} onChange={e => setForm({ ...form, varsayilan_brut_maas: e.target.value })} />
              <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>Çalışanın eline geçmesi gereken aylık net toplam.</div>
            </div>
            <div>
              <label style={labelStyle}>Günlük Yol Ücreti (₺/gün)</label>
              <input style={inputStyle} type="number" step="0.01" value={form.gunluk_yol_ucreti} onChange={e => setForm({ ...form, gunluk_yol_ucreti: e.target.value })} />
              <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>Puantajda yol = gelinen gün × günlük ücret olarak hesaplanır.</div>
            </div>

            {form.tip === 'KADRO' && (
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={labelStyle}>Resmi Maaş Tabanı (30 gün) ₺</label>
                <input style={inputStyle} type="number" step="0.01" value={form.varsayilan_resmi_odeme} onChange={e => setForm({ ...form, varsayilan_resmi_odeme: e.target.value })} />
                <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>KADRO için banka/resmi taban; çalışılan güne göre otomatik oranlanır. Serbest/part-time'da kullanılmaz (hepsi elden).</div>
              </div>
            )}

            {/* İşe çıkış tarihi sadece düzenleme modunda + çıkış tarihi dolu ise */}
            {editing && form.ise_cikis_tarihi && (
              <div style={{ gridColumn: '1/-1' }}>
                <label style={labelStyle}>İşe Çıkış Tarihi</label>
                <input style={inputStyle} type="date" value={form.ise_cikis_tarihi} onChange={e => setForm({ ...form, ise_cikis_tarihi: e.target.value })} />
                <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>Çıkış akışı ile otomatik doldu — gerekirse düzenle.</div>
              </div>
            )}
          </div>
        </div>

        {/* 5. Nitelikler */}
        <div style={sectionStyle}>
          <div style={sectionTitle}>Nitelikler</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            <div>
              <label style={labelStyle}>Öğrenim Durumu</label>
              <select
                style={inputStyle}
                value={form.ogrenim_durumu}
                onChange={e => setForm({ ...form, ogrenim_durumu: e.target.value })}
              >
                {OGRENIM_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>İngilizce Seviyesi</label>
              <select
                style={inputStyle}
                value={form.ingilizce_seviyesi}
                onChange={e => setForm({ ...form, ingilizce_seviyesi: e.target.value })}
              >
                {INGILIZCE_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Askerlik Durumu</label>
              <select
                style={inputStyle}
                value={form.askerlik_durumu}
                onChange={e => setForm({ ...form, askerlik_durumu: e.target.value })}
              >
                {ASKERLIK_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 22 }}>
              <input
                type="checkbox"
                id="ozel-saglik-sigortasi"
                checked={!!form.ozel_saglik_sigortasi}
                onChange={e => setForm({ ...form, ozel_saglik_sigortasi: e.target.checked })}
                style={{ cursor: 'pointer' }}
              />
              <label
                htmlFor="ozel-saglik-sigortasi"
                style={{ fontSize: 12, fontWeight: 600, color: '#333', cursor: 'pointer' }}
              >
                Özel Sağlık Sigortası Var
              </label>
            </div>
          </div>
        </div>

        {/* Not */}
        <div>
          <label style={labelStyle}>Not</label>
          <textarea style={{ ...inputStyle, minHeight: 60, fontFamily: 'inherit' }} value={form.notlar} onChange={e => setForm({ ...form, notlar: e.target.value })} />
        </div>
      </div>
    );
  };

  // C3: Deneme Süresi tab render
  const renderDeneme = () => {
    if (!editing || !personel?.id) {
      return renderPlaceholder('Deneme Süresi sekmesi için önce personeli kaydedin.');
    }

    // Çalışma süresi hesabı
    const ise_giris = form.ise_giris_tarihi || personel.ise_giris_tarihi;
    let calismaMetni = '—';
    let toplamGun = 0;
    if (ise_giris) {
      const start = new Date(ise_giris);
      const now = new Date();
      toplamGun = Math.max(0, Math.floor((now - start) / (1000 * 60 * 60 * 24)));
      const ay = Math.floor(toplamGun / 30);
      const kalanGun = toplamGun - ay * 30;
      if (ay === 0) {
        calismaMetni = `${kalanGun} gün çalıştı`;
      } else if (kalanGun === 0) {
        calismaMetni = `${ay} ay çalıştı`;
      } else {
        calismaMetni = `${ay} ay ${kalanGun} gün çalıştı`;
      }
    }

    const erkenDegerlendirme = toplamGun > 0 && toplamGun < 30;

    return (
      <div>
        {/* Çalışma süresi bilgi kutusu */}
        <div style={{
          background: '#eef4ff',
          border: '1px solid #c4d5ff',
          borderRadius: radius.sm,
          padding: 12,
          marginBottom: 14,
          fontSize: 13,
        }}>
          <div style={{ fontWeight: 600, color: '#1e40af', marginBottom: 4 }}>
            ⏱️ Çalışma Süresi
          </div>
          <div style={{ color: '#334155' }}>
            İşe giriş: <strong>{ise_giris || '-'}</strong> — {calismaMetni}
          </div>
        </div>

        {erkenDegerlendirme && (
          <div style={{
            background: '#fff8e1',
            border: '1px solid #f2c94c',
            borderRadius: radius.sm,
            padding: 10,
            marginBottom: 14,
            fontSize: 12,
            color: '#8a6d00',
          }}>
            ⚠️ Personel henüz 1 ayı doldurmadı — erken değerlendirme yapıyorsunuz.
          </div>
        )}

        <div>
          <label style={{ ...hrLabel, marginBottom: 4 }}>Deneme Sonucu</label>
          <select
            style={{ ...hrInput, width: '100%' }}
            value={denemeSonucu}
            onChange={e => setDenemeSonucu(e.target.value)}
          >
            <option value="DEGERLENDIRILMEDI">Henüz değerlendirilmedi</option>
            <option value="UYGUN">✅ İşletmeye uygun</option>
            <option value="UYGUN_DEGIL">❌ İşletmeye uygun değil</option>
          </select>
          <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>
            UYGUN veya UYGUN_DEGIL seçerseniz ilgili deneme süresi bildirimleri otomatik kapanır.
          </div>
        </div>

        <div style={{ marginTop: 12 }}>
          <label style={{ ...hrLabel, marginBottom: 4 }}>Deneme Notu</label>
          <textarea
            style={{
              ...hrInput,
              width: '100%',
              minHeight: 80,
              fontFamily: 'inherit',
            }}
            placeholder="Değerlendirme notları..."
            value={denemeNotu}
            onChange={e => setDenemeNotu(e.target.value)}
          />
        </div>

        <div style={{ marginTop: 14 }}>
          <button
            onClick={handleDenemeKaydet}
            disabled={denemeSaving}
            style={{
              padding: '8px 16px',
              background: denemeSaving ? '#aaa' : styles.success,
              color: 'white',
              border: 'none',
              borderRadius: radius.sm,
              cursor: denemeSaving ? 'not-allowed' : 'pointer',
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {denemeSaving ? 'Kaydediliyor...' : 'Deneme Durumunu Kaydet'}
          </button>
        </div>
      </div>
    );
  };

  const renderPlaceholder = (msg) => (
    <div style={{ padding: 40, textAlign: 'center', color: '#888', fontSize: 13 }}>
      {msg}
    </div>
  );

  // D4: Kıdem tahminini yükle
  const loadKidemTahmin = async () => {
    if (!editing || !personel?.id) return;
    setKidemLoading(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/kidem-tahmini`, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      if (r.ok) {
        setKidemTahmin(await r.json());
      } else {
        toast.error('Kıdem tahmini alınamadı');
      }
    } catch {
      toast.error('Bağlantı hatası (kıdem)');
    } finally {
      setKidemLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'kidem' && editing && !kidemTahmin && !kidemLoading) {
      loadKidemTahmin();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // D4: Çıkış işle
  const handleCikisYap = async () => {
    if (!editing || !personel?.id) return;
    if (!window.confirm(
      `${personel.ad_soyad} için işten çıkış kaydı oluşturulacak.\n\n` +
      `Çıkış tarihi: ${cikisForm.cikis_tarihi}\n` +
      `Sebep: ${cikisForm.cikis_sebebi}\n\n` +
      `Bu işlem geri alınmaz (personel pasif olur). Devam edilsin mi?`
    )) return;

    setCikisSaving(true);
    try {
      const r = await fetch(`${API_URL}/api/hr/personel/${personel.id}/cikis`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cikis_tarihi: cikisForm.cikis_tarihi,
          cikis_sebebi: cikisForm.cikis_sebebi,
          notlar: cikisForm.notlar || null,
        }),
      });
      if (r.ok) {
        const data = await r.json();
        if (data.hak_var) {
          // kidem_takip kapalıyken kayıt OLUŞMAZ (kidem_kaydi=null); tutarı her zaman
          // dönen hesap_detay'dan oku (null-crash'i önle).
          const tutar = Number(data.hesap_detay?.hesaplanan_tutar || 0).toLocaleString('tr-TR');
          if (data.kidem_takip) {
            toast.success(`Çıkış tamamlandı. Kıdem tazminatı kaydı oluşturuldu: ${tutar} ₺ (ödeme bekliyor)`);
          } else {
            toast.info(`Çıkış tamamlandı. Kıdem tazminatı (bilgi amaçlı): ${tutar} ₺ — sisteme işlenmedi.`);
          }
        } else {
          toast.info('Çıkış tamamlandı. Bu sebep için kıdem hakkı yok.');
        }
        onSaved();
      } else {
        const err = await r.json().catch(() => ({}));
        toast.error(err.detail || 'Çıkış işleminde hata oluştu');
      }
    } catch {
      toast.error('Bağlantı hatası');
    } finally {
      setCikisSaving(false);
    }
  };

  // γ2 — Maaş & Zam tab render
  const renderMaas = () => {
    if (!editing || !personel?.id) {
      return renderPlaceholder('Maaş & Zam sekmesi için önce personeli kaydedin.');
    }
    const mevcutBrut = parseFloat(form.varsayilan_brut_maas) || 0;
    const mevcutGunlukYol = parseFloat(form.gunluk_yol_ucreti) || 0;

    return (
      <div>
        {/* Mevcut kart */}
        <div style={{
          background: '#e3f2fd',
          border: '1px solid #64b5f6',
          borderRadius: radius.sm,
          padding: 14,
          marginBottom: 14,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div>
            <div style={{ fontSize: 11, color: '#0d47a1', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
              Mevcut Maaş
            </div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#1565c0', marginTop: 4 }}>
              {fmtTutar(mevcutBrut)} ₺
              <span style={{ fontSize: 12, fontWeight: 400, color: '#555', marginLeft: 10 }}>
                Yol: {fmtTutar(mevcutGunlukYol)} ₺/gün
              </span>
            </div>
          </div>
          {!maasFormOpen && (
            <button
              onClick={() => {
                // Form açıldığında default değerler
                setMaasForm({
                  yeni_brut_maas: '',
                  yeni_yol_yardimi: mevcutGunlukYol.toString(),
                  yuzde: '',
                  neden: 'YILLIK_ZAM',
                  tarih: new Date().toISOString().split('T')[0],
                  notlar: '',
                });
                setMaasFormOpen(true);
              }}
              style={{
                padding: '8px 16px',
                background: styles.success,
                color: 'white',
                border: 'none',
                borderRadius: radius.sm,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              + Zam Yap
            </button>
          )}
        </div>

        {/* Zam formu */}
        {maasFormOpen && (
          <div style={{
            background: '#fafafa',
            border: `1px solid ${colors.border}`,
            borderRadius: radius.sm,
            padding: 14,
            marginBottom: 14,
          }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 10 }}>
              Yeni Zam Kaydı
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div>
                <label style={hrLabel}>Yeni Brüt Maaş (₺) *</label>
                <input
                  type="number"
                  step="0.01"
                  value={maasForm.yeni_brut_maas}
                  onChange={handleYeniBrutChange}
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
              <div>
                <label style={hrLabel}>Veya Yüzde (%)</label>
                <input
                  type="number"
                  step="0.01"
                  value={maasForm.yuzde}
                  onChange={handleYuzdeChange}
                  placeholder="ör. 25"
                  style={{ ...hrInput, width: '100%' }}
                />
                <div style={{ fontSize: 10, color: '#888', marginTop: 3 }}>
                  Yüzde ↔ brüt iki yönlü hesaplanır.
                </div>
              </div>
              <div>
                <label style={hrLabel}>Günlük Yol (₺/gün)</label>
                <input
                  type="number"
                  step="0.01"
                  value={maasForm.yeni_yol_yardimi}
                  onChange={e => setMaasForm(f => ({ ...f, yeni_yol_yardimi: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
              <div>
                <label style={hrLabel}>Neden *</label>
                <select
                  value={maasForm.neden}
                  onChange={e => setMaasForm(f => ({ ...f, neden: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                >
                  {MAAS_NEDEN_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                </select>
              </div>
              <div>
                <label style={hrLabel}>Tarih *</label>
                <input
                  type="date"
                  value={maasForm.tarih}
                  onChange={e => setMaasForm(f => ({ ...f, tarih: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
              <div>
                <label style={hrLabel}>Notlar</label>
                <input
                  type="text"
                  value={maasForm.notlar}
                  onChange={e => setMaasForm(f => ({ ...f, notlar: e.target.value }))}
                  placeholder="Opsiyonel"
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <button
                onClick={handleMaasKaydet}
                disabled={maasSaving}
                style={{
                  padding: '8px 16px',
                  background: maasSaving ? '#aaa' : styles.success,
                  color: 'white',
                  border: 'none',
                  borderRadius: radius.sm,
                  cursor: maasSaving ? 'not-allowed' : 'pointer',
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {maasSaving ? 'Kaydediliyor...' : 'Zam Kaydını Oluştur'}
              </button>
              <button
                onClick={() => setMaasFormOpen(false)}
                disabled={maasSaving}
                style={{
                  padding: '8px 16px',
                  background: '#eee',
                  border: `1px solid ${colors.border}`,
                  borderRadius: radius.sm,
                  cursor: 'pointer',
                  fontSize: 12,
                }}
              >
                İptal
              </button>
            </div>
          </div>
        )}

        {/* Geçmiş tablo */}
        {maasLoading ? (
          renderPlaceholder('Geçmiş yükleniyor...')
        ) : maasGecmisi.length === 0 ? (
          <div style={{
            padding: 20,
            textAlign: 'center',
            color: '#888',
            fontSize: 12,
            border: `1px dashed ${colors.border}`,
            borderRadius: radius.sm,
          }}>
            Henüz zam kaydı yok. İlk zam yapılınca kayıt oluşur.
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Tarih</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Eski Brüt</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Yeni Brüt</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Artış %</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Günlük Yol</th>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Neden</th>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Not</th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>İşlem</th>
                </tr>
              </thead>
              <tbody>
                {maasGecmisi.map(k => (
                  <tr key={k.id} style={{ borderBottom: `1px solid ${colors.border}` }}>
                    <td style={{ padding: '6px 8px' }}>{k.tarih}</td>
                    <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtTutar(k.eski_brut_maas)} ₺</td>
                    <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace', fontWeight: 600 }}>{fmtTutar(k.yeni_brut_maas)} ₺</td>
                    <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace', color: k.artis_yuzdesi > 0 ? '#2e7d32' : '#666' }}>
                      {k.artis_yuzdesi != null ? `%${k.artis_yuzdesi.toFixed(2)}` : '—'}
                    </td>
                    <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{fmtTutar(k.yeni_yol_yardimi)} ₺</td>
                    <td style={{ padding: '6px 8px' }}>{MAAS_NEDEN_LABELS[k.neden] || k.neden}</td>
                    <td style={{ padding: '6px 8px', color: '#666', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis' }} title={k.notlar || ''}>
                      {k.notlar || '—'}
                    </td>
                    <td style={{ padding: '6px 8px', textAlign: 'center' }}>
                      <button
                        type="button"
                        onClick={() => handleMaasSil(k)}
                        disabled={maasSaving}
                        title="Maaş kaydını sil"
                        style={{
                          padding: '4px 9px',
                          background: maasSaving ? '#aaa' : '#d32f2f',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 4,
                          cursor: maasSaving ? 'not-allowed' : 'pointer',
                          fontSize: 10,
                          fontWeight: 600,
                        }}
                      >
                        Sil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // γ3 — İzinler tab render
  const renderIzinler = () => {
    if (!editing || !personel?.id) {
      return renderPlaceholder('İzinler sekmesi için önce personeli kaydedin.');
    }
    if (izinLoading) {
      return renderPlaceholder('İzin bakiyesi yükleniyor...');
    }
    if (!izinOzeti) {
      return (
        <div>
          {renderPlaceholder('Özet alınamadı.')}
          <div style={{ textAlign: 'center', marginTop: 10 }}>
            <button
              onClick={loadIzinOzeti}
              style={{
                padding: '6px 14px',
                background: '#1565c0',
                color: 'white',
                border: 'none',
                borderRadius: radius.sm,
                cursor: 'pointer',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              Tekrar Dene
            </button>
          </div>
        </div>
      );
    }

    const {
      yillik_hak_gun = 0,
      yillik_kullanilan = 0,
      yillik_bakiye = 0,
      rapor_toplam_gun = 0,
      mazeret_toplam_gun = 0,
      ucretsiz_toplam_gun = 0,
      yil_bazli = [],
      son_izinler = [],
    } = izinOzeti;

    // Bakiye rengi
    let bakiyeColor = '#2bc275';  // yeşil
    if (yillik_bakiye < 0) bakiyeColor = '#d9534f';  // kırmızı
    else if (yillik_bakiye < 5) bakiyeColor = '#f0ad4e';  // sarı

    // Progress bar yüzde (0-100 arası clamp)
    const progressPct = yillik_hak_gun > 0
      ? Math.min(100, Math.max(0, Math.round((yillik_kullanilan / yillik_hak_gun) * 100)))
      : 0;
    let progressColor = '#2bc275';
    if (progressPct >= 90) progressColor = '#d9534f';
    else if (progressPct >= 60) progressColor = '#f0ad4e';

    return (
      <div>
        {/* Üst büyük bakiye kartı */}
        <div style={{
          background: 'white',
          border: `2px solid ${bakiyeColor}`,
          borderRadius: radius.md,
          padding: 16,
          marginBottom: 14,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 11, color: '#666', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
            Yıllık İzin Bakiyesi
          </div>
          <div style={{ fontSize: 36, fontWeight: 700, color: bakiyeColor, margin: '4px 0' }}>
            {yillik_bakiye} gün
          </div>
          <div style={{ fontSize: 12, color: '#555' }}>
            Hak: <strong>{yillik_hak_gun} gün</strong>
            {' | '}
            Kullanılan: <strong>{yillik_kullanilan} gün</strong>
          </div>

          {/* Progress bar */}
          <div style={{
            marginTop: 10,
            height: 10,
            background: '#eee',
            borderRadius: 5,
            overflow: 'hidden',
          }}>
            <div style={{
              width: `${progressPct}%`,
              height: '100%',
              background: progressColor,
              transition: 'width 0.3s',
            }} />
          </div>
          <div style={{ fontSize: 10, color: '#888', marginTop: 4 }}>
            %{progressPct} kullanıldı
          </div>
        </div>

        {/* Yan kartlar — rapor / mazeret / ücretsiz */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 14 }}>
          {[
            { label: 'Rapor', value: rapor_toplam_gun, color: '#e91e63' },
            { label: 'Mazeret', value: mazeret_toplam_gun, color: '#9c27b0' },
            { label: 'Ücretsiz', value: ucretsiz_toplam_gun, color: '#607d8b' },
          ].map(k => (
            <div key={k.label} style={{
              background: 'white',
              border: `1px solid ${colors.border}`,
              borderLeft: `3px solid ${k.color}`,
              borderRadius: radius.sm,
              padding: 10,
            }}>
              <div style={{ fontSize: 10, color: '#666', fontWeight: 600, textTransform: 'uppercase' }}>
                {k.label}
              </div>
              <div style={{ fontSize: 18, fontWeight: 700, color: k.color, marginTop: 2 }}>
                {k.value} gün
              </div>
            </div>
          ))}
        </div>

        {/* Yıl bazlı tablo */}
        {yil_bazli.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 6 }}>
              Yıl Bazlı Dağılım
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
                <thead>
                  <tr style={{ background: '#fafafa' }}>
                    <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Yıl</th>
                    <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Yıllık</th>
                    <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Mazeret</th>
                    <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Rapor</th>
                    <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Ücretsiz</th>
                  </tr>
                </thead>
                <tbody>
                  {yil_bazli.map(y => (
                    <tr key={y.yil} style={{ borderBottom: `1px solid ${colors.border}` }}>
                      <td style={{ padding: '6px 8px', fontWeight: 600 }}>{y.yil}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{y.yillik || 0}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{y.mazeret || 0}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{y.rapor || 0}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'right', fontFamily: 'monospace' }}>{y.ucretsiz || 0}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Son izinler */}
        {son_izinler.length > 0 && (
          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#555', marginBottom: 6 }}>
              Son İzinler
            </div>
            <div style={{ border: `1px solid ${colors.border}`, borderRadius: radius.sm }}>
              {son_izinler.map((i, idx) => (
                <div key={idx} style={{
                  padding: '6px 10px',
                  borderBottom: idx < son_izinler.length - 1 ? `1px solid ${colors.border}` : 'none',
                  display: 'grid',
                  gridTemplateColumns: '90px 80px 50px 1fr',
                  gap: 8,
                  fontSize: 11,
                  alignItems: 'center',
                }}>
                  <div style={{ color: '#666' }}>{i.tarih}</div>
                  <div style={{ fontWeight: 600 }}>{IZIN_TIP_LABELS[i.tip] || i.tip}</div>
                  <div style={{ textAlign: 'right', fontFamily: 'monospace' }}>{i.gun} gün</div>
                  <div style={{ color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {i.aciklama || ''}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Yeni izin ekle link */}
        <div style={{ textAlign: 'center', marginTop: 10 }}>
          <a
            href="/ik?tab=izin"
            style={{
              display: 'inline-block',
              padding: '8px 16px',
              background: '#1565c0',
              color: 'white',
              textDecoration: 'none',
              borderRadius: radius.sm,
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            Yeni İzin Ekle →
          </a>
        </div>
      </div>
    );
  };

  // γ4 — Disiplin tab render
  const renderDisiplin = () => {
    if (!editing || !personel?.id) {
      return renderPlaceholder('Disiplin sekmesi için önce personeli kaydedin.');
    }
    const today = new Date().toISOString().split('T')[0];

    return (
      <div>
        {/* Üst buton */}
        {!disiplinFormOpen && (
          <div style={{ marginBottom: 12 }}>
            <button
              onClick={() => setDisiplinFormOpen(true)}
              style={{
                padding: '8px 16px',
                background: '#d32f2f',
                color: 'white',
                border: 'none',
                borderRadius: radius.sm,
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 12,
              }}
            >
              + Yeni Disiplin Kaydı
            </button>
          </div>
        )}

        {/* Inline form */}
        {disiplinFormOpen && (
          <div style={{
            background: '#fafafa',
            border: `1px solid ${colors.border}`,
            borderRadius: radius.sm,
            padding: 14,
            marginBottom: 14,
          }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 10 }}>
              Yeni Disiplin Kaydı
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div>
                <label style={hrLabel}>Tarih *</label>
                <input
                  type="date"
                  value={disiplinForm.tarih}
                  onChange={e => setDisiplinForm(f => ({ ...f, tarih: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
              <div>
                <label style={hrLabel}>Tip *</label>
                <select
                  value={disiplinForm.tip}
                  onChange={e => setDisiplinForm(f => ({ ...f, tip: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                >
                  {DISIPLIN_TIP_OPTIONS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                </select>
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <label style={hrLabel}>Açıklama *</label>
                <textarea
                  value={disiplinForm.aciklama}
                  onChange={e => setDisiplinForm(f => ({ ...f, aciklama: e.target.value }))}
                  style={{ ...hrInput, width: '100%', minHeight: 60, fontFamily: 'inherit' }}
                  placeholder="Disiplin kaydı için açıklama..."
                />
              </div>
            </div>
            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <button
                onClick={handleDisiplinKaydet}
                disabled={disiplinSaving}
                style={{
                  padding: '8px 16px',
                  background: disiplinSaving ? '#aaa' : styles.success,
                  color: 'white',
                  border: 'none',
                  borderRadius: radius.sm,
                  cursor: disiplinSaving ? 'not-allowed' : 'pointer',
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {disiplinSaving ? 'Kaydediliyor...' : 'Kaydı Oluştur'}
              </button>
              <button
                onClick={() => setDisiplinFormOpen(false)}
                disabled={disiplinSaving}
                style={{
                  padding: '8px 16px',
                  background: '#eee',
                  border: `1px solid ${colors.border}`,
                  borderRadius: radius.sm,
                  cursor: 'pointer',
                  fontSize: 12,
                }}
              >
                İptal
              </button>
            </div>
          </div>
        )}

        {/* Kayıt listesi */}
        {disiplinLoading ? (
          renderPlaceholder('Kayıtlar yükleniyor...')
        ) : disiplinKayitlari.length === 0 ? (
          <div style={{
            padding: 20,
            textAlign: 'center',
            color: '#888',
            fontSize: 12,
            border: `1px dashed ${colors.border}`,
            borderRadius: radius.sm,
          }}>
            Disiplin kaydı yok.
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 11 }}>
              <thead>
                <tr style={{ background: '#fafafa' }}>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Tarih</th>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Tip</th>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Açıklama</th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: 10, fontWeight: 700, color: '#555', borderBottom: `2px solid ${colors.border}` }}>Aksiyon</th>
                </tr>
              </thead>
              <tbody>
                {disiplinKayitlari.map(k => {
                  const ayniGun = k.tarih === today;
                  return (
                    <tr key={k.id} style={{ borderBottom: `1px solid ${colors.border}` }}>
                      <td style={{ padding: '6px 8px' }}>{k.tarih}</td>
                      <td style={{ padding: '6px 8px', fontWeight: 600 }}>
                        {DISIPLIN_TIP_LABELS[k.tip] || k.tip}
                      </td>
                      <td style={{ padding: '6px 8px', color: '#555' }}>{k.aciklama}</td>
                      <td style={{ padding: '6px 8px', textAlign: 'center' }}>
                        {ayniGun ? (
                          <button
                            onClick={() => handleDisiplinSil(k)}
                            style={{
                              padding: '3px 10px',
                              background: '#d32f2f',
                              color: 'white',
                              border: 'none',
                              borderRadius: radius.sm,
                              cursor: 'pointer',
                              fontSize: 10,
                              fontWeight: 600,
                            }}
                            title="Aynı gün kaydı — silinebilir"
                          >
                            Sil
                          </button>
                        ) : (
                          <span style={{ fontSize: 10, color: '#bbb' }}>—</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const renderKidem = () => {
    if (!editing || !personel?.id) {
      return renderPlaceholder('Kıdem Özeti sekmesi için önce personeli kaydedin.');
    }
    if (kidemLoading) {
      return renderPlaceholder('Kıdem tahmini yükleniyor...');
    }

    const aktif = personel.aktif !== false;
    const cikisBilgileri = !aktif && personel.ise_cikis_tarihi;

    // Kıdem tahmin paneli değerleri
    const t = kidemTahmin || {};
    const calismaYili = t.calisma_yili || 0;
    const yilTam = Math.floor(calismaYili);
    const ayKalan = Math.round((calismaYili - yilTam) * 12);
    const calismaMetni = `${yilTam} yıl ${ayKalan} ay`;
    const tavanUygulaniyor =
      t.hak_var &&
      t.uygulanan_tavan > 0 &&
      t.giydirilmis_brut > t.uygulanan_tavan;

    const tutarStr = (v) => Number(v || 0).toLocaleString('tr-TR', { maximumFractionDigits: 2 });

    const CIKIS_SEBEP_OPTIONS = [
      { v: 'ISVEREN_FESHI', l: 'İşveren Feshi (haksız fesih)' },
      { v: 'ISTIFA', l: 'İstifa' },
      { v: 'DENEME_FESHI', l: 'Deneme Süresi Feshi' },
      { v: 'EMEKLILIK', l: 'Emeklilik' },
      { v: 'ASKERLIK', l: 'Askerlik' },
      { v: 'EVLILIK', l: 'Evlilik (1 yıl içinde kadın işçi)' },
      { v: 'VEFAT', l: 'Vefat' },
      { v: 'HAKLI_NEDEN', l: 'Haklı Neden (İş K. md.24)' },
    ];

    return (
      <div>
        {/* Çıkış yapmış personel bilgi kartı */}
        {cikisBilgileri && (
          <div style={{
            background: '#fff3e0',
            border: '1px solid #ffb74d',
            borderRadius: radius.sm,
            padding: 12,
            marginBottom: 14,
            fontSize: 13,
          }}>
            <div style={{ fontWeight: 600, color: '#e65100', marginBottom: 4 }}>
              🚪 İşten Ayrılmış Personel
            </div>
            <div style={{ color: '#5d4037' }}>
              Çıkış tarihi: <strong>{personel.ise_cikis_tarihi}</strong>
              {personel.cikis_sebebi && <> | Sebep: <strong>{personel.cikis_sebebi}</strong></>}
            </div>
          </div>
        )}

        {/* Tahmin paneli */}
        {kidemTahmin && (
          <div style={{
            background: t.hak_var ? '#e3f2fd' : '#f5f5f5',
            border: `1px solid ${t.hak_var ? '#64b5f6' : '#bbb'}`,
            borderRadius: radius.sm,
            padding: 14,
            marginBottom: 14,
          }}>
            <div style={{ fontWeight: 600, fontSize: 13, color: '#0d47a1', marginBottom: 10 }}>
              📊 Kıdem Tazminatı Tahmini
              <span style={{ fontWeight: 400, fontSize: 10, color: '#666', marginLeft: 6 }}>
                (bugün itibariyle, işveren feshi senaryosu)
              </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, fontSize: 12 }}>
              <div>
                <div style={{ color: '#666' }}>Çalışma Süresi</div>
                <div style={{ fontWeight: 600 }}>{calismaMetni}</div>
              </div>
              <div>
                <div style={{ color: '#666' }}>Hak Edilen Gün</div>
                <div style={{ fontWeight: 600 }}>{t.hak_edilen_gun || 0} gün</div>
              </div>
              <div>
                <div style={{ color: '#666' }}>Giydirilmiş Brüt</div>
                <div style={{ fontWeight: 600 }}>{tutarStr(t.giydirilmis_brut)} ₺</div>
              </div>
              <div>
                <div style={{ color: '#666' }}>Tavan Durumu</div>
                <div style={{ fontWeight: 600, fontSize: 11 }}>
                  {tavanUygulaniyor
                    ? `⚠️ Tavan uygulanıyor (${tutarStr(t.uygulanan_tavan)} ₺)`
                    : `Tavan altında (${tutarStr(t.uygulanan_tavan)} ₺)`}
                </div>
              </div>
            </div>

            <div style={{
              marginTop: 12,
              paddingTop: 10,
              borderTop: '1px solid #bbdefb',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}>
              <div style={{ fontSize: 12, color: '#666' }}>Tahmini Tutar</div>
              <div style={{
                fontSize: 22,
                fontWeight: 700,
                color: t.hak_var ? '#1565c0' : '#999',
              }}>
                {tutarStr(t.hesaplanan_tutar)} ₺
              </div>
            </div>

            {!t.hak_var && calismaYili < 1 && (
              <div style={{
                marginTop: 10,
                padding: 8,
                background: '#fff8e1',
                border: '1px solid #f2c94c',
                borderRadius: 4,
                fontSize: 11,
                color: '#8a6d00',
              }}>
                ⚠️ Personel henüz 1 yılı doldurmadı — kıdem tazminatı hakkı yok.
              </div>
            )}
          </div>
        )}

        {/* Çıkış Yap bölümü — sadece aktif personel için */}
        {aktif && !cikisFormOpen && (
          <button
            onClick={() => setCikisFormOpen(true)}
            style={{
              padding: '10px 18px',
              background: '#d32f2f',
              color: 'white',
              border: 'none',
              borderRadius: radius.sm,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            🚪 Çıkış Yap
          </button>
        )}

        {aktif && cikisFormOpen && (
          <div style={{
            background: '#fafafa',
            border: `1px solid ${colors.border}`,
            borderRadius: radius.sm,
            padding: 14,
          }}>
            <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 10 }}>
              Çıkış Bilgileri
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div>
                <label style={{ ...hrLabel, marginBottom: 4 }}>Çıkış Tarihi *</label>
                <input
                  type="date"
                  value={cikisForm.cikis_tarihi}
                  onChange={e => setCikisForm(f => ({ ...f, cikis_tarihi: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                />
              </div>
              <div>
                <label style={{ ...hrLabel, marginBottom: 4 }}>Çıkış Sebebi *</label>
                <select
                  value={cikisForm.cikis_sebebi}
                  onChange={e => setCikisForm(f => ({ ...f, cikis_sebebi: e.target.value }))}
                  style={{ ...hrInput, width: '100%' }}
                >
                  {CIKIS_SEBEP_OPTIONS.map(o => (
                    <option key={o.v} value={o.v}>{o.l}</option>
                  ))}
                </select>
              </div>
            </div>

            <div style={{ marginTop: 10 }}>
              <label style={{ ...hrLabel, marginBottom: 4 }}>Notlar</label>
              <textarea
                style={{ ...hrInput, width: '100%', minHeight: 60, fontFamily: 'inherit' }}
                placeholder="Çıkış sebebiyle ilgili notlar..."
                value={cikisForm.notlar}
                onChange={e => setCikisForm(f => ({ ...f, notlar: e.target.value }))}
              />
            </div>

            <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
              <button
                onClick={handleCikisYap}
                disabled={cikisSaving}
                style={{
                  padding: '8px 16px',
                  background: cikisSaving ? '#aaa' : '#d32f2f',
                  color: 'white',
                  border: 'none',
                  borderRadius: radius.sm,
                  cursor: cikisSaving ? 'not-allowed' : 'pointer',
                  fontWeight: 600,
                  fontSize: 12,
                }}
              >
                {cikisSaving ? 'İşleniyor...' : 'Çıkışı Tamamla'}
              </button>
              <button
                onClick={() => setCikisFormOpen(false)}
                disabled={cikisSaving}
                style={{
                  padding: '8px 16px',
                  background: '#eee',
                  border: `1px solid ${colors.border}`,
                  borderRadius: radius.sm,
                  cursor: 'pointer',
                  fontSize: 12,
                }}
              >
                İptal
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderBelgeler = () => {
    if (!editing) {
      return renderPlaceholder('Belgeler sekmesi için önce personeli kaydedin.');
    }
    if (belgeLoading) {
      return renderPlaceholder('Belgeler yükleniyor...');
    }
    if (belgeler.length === 0) {
      return renderPlaceholder('Aktif belge türü yok.');
    }
    const today = new Date().toISOString().split('T')[0];
    const dirtyCount = Object.values(belgeDirty).filter(Boolean).length;

    return (
      <div>
        <div style={{ fontSize: 11, color: '#666', marginBottom: 10 }}>
          Süreli belgelerde geçerlilik tarihi boş bırakılırsa alınma tarihine
          belge türünün varsayılan süresi (ay) eklenerek otomatik hesaplanır.
        </div>
        <div style={{ border: `1px solid ${colors.border}`, borderRadius: radius.sm }}>
          {belgeler.map((b, idx) => {
            const vadeGecti = b.son_gecerlilik_tarihi && b.son_gecerlilik_tarihi < today;
            return (
              <div
                key={b.belge_turu_id}
                style={{
                  padding: 10,
                  borderBottom: idx < belgeler.length - 1 ? `1px solid ${colors.border}` : 'none',
                  background: belgeDirty[b.belge_turu_id] ? '#fff9e6' : 'white',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <input
                    type="checkbox"
                    checked={!!b.alindi}
                    onChange={e => updateBelgeRow(b.belge_turu_id, { alindi: e.target.checked })}
                    style={{ cursor: 'pointer' }}
                  />
                  <div style={{ fontWeight: 600, fontSize: 12, flex: 1 }}>
                    {b.belge_turu_ad}
                    {b.zorunlu && <span style={{ color: '#d32f2f', marginLeft: 4 }}>*</span>}
                    {b.sureli && (
                      <span style={{ marginLeft: 6, fontSize: 10, background: '#e3f2fd', color: '#1565c0', padding: '1px 6px', borderRadius: 3 }}>
                        SÜRELİ {b.varsayilan_gecerlilik_ay ? `(${b.varsayilan_gecerlilik_ay} ay)` : ''}
                      </span>
                    )}
                    {vadeGecti && (
                      <span style={{ marginLeft: 6, fontSize: 10, background: '#ffebee', color: '#c62828', padding: '1px 6px', borderRadius: 3 }}>
                        VADE GEÇTİ
                      </span>
                    )}
                  </div>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: b.sureli ? '1fr 1fr 2fr' : '1fr 2fr', gap: 8 }}>
                  <div>
                    <label style={{ display: 'block', fontSize: 10, color: '#666', marginBottom: 2 }}>Alınma Tarihi</label>
                    <input
                      type="date"
                      value={b.alinma_tarihi || ''}
                      onChange={e => updateBelgeRow(b.belge_turu_id, { alinma_tarihi: e.target.value })}
                      style={{ width: '100%', padding: '5px 8px', fontSize: 12, border: `1px solid ${colors.border}`, borderRadius: radius.sm, boxSizing: 'border-box' }}
                      disabled={!b.alindi}
                    />
                  </div>
                  {b.sureli && (
                    <div>
                      <label style={{ display: 'block', fontSize: 10, color: '#666', marginBottom: 2 }}>
                        Geçerlilik Son Tarihi
                      </label>
                      <input
                        type="date"
                        value={b.son_gecerlilik_tarihi || ''}
                        onChange={e => updateBelgeRow(b.belge_turu_id, { son_gecerlilik_tarihi: e.target.value })}
                        style={{ width: '100%', padding: '5px 8px', fontSize: 12, border: `1px solid ${colors.border}`, borderRadius: radius.sm, boxSizing: 'border-box' }}
                        disabled={!b.alindi}
                        title="Boş bırakırsanız otomatik hesaplanır"
                      />
                    </div>
                  )}
                  <div>
                    <label style={{ display: 'block', fontSize: 10, color: '#666', marginBottom: 2 }}>Not</label>
                    <input
                      type="text"
                      value={b.notlar || ''}
                      onChange={e => updateBelgeRow(b.belge_turu_id, { notlar: e.target.value })}
                      style={{ width: '100%', padding: '5px 8px', fontSize: 12, border: `1px solid ${colors.border}`, borderRadius: radius.sm, boxSizing: 'border-box' }}
                      placeholder="Opsiyonel"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, alignItems: 'center' }}>
          <button
            onClick={handleBelgeKaydet}
            disabled={belgeSaving || dirtyCount === 0}
            style={{
              padding: '8px 14px',
              background: dirtyCount > 0 ? styles.success : '#aaa',
              color: 'white',
              border: 'none',
              borderRadius: radius.sm,
              cursor: dirtyCount === 0 || belgeSaving ? 'not-allowed' : 'pointer',
              fontWeight: 600,
              fontSize: 12,
            }}
          >
            {belgeSaving ? 'Kaydediliyor...' : `Belge Değişikliklerini Kaydet${dirtyCount > 0 ? ` (${dirtyCount})` : ''}`}
          </button>
          {dirtyCount > 0 && (
            <button
              onClick={loadBelgeler}
              disabled={belgeSaving}
              style={{ padding: '8px 14px', background: '#eee', border: `1px solid ${colors.border}`, borderRadius: radius.sm, cursor: 'pointer', fontSize: 12 }}
            >
              Değişiklikleri İptal Et
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={onClose}>
      <div style={{ background: colors.surface, padding: 24, borderRadius: radius.lg, width: 640, maxWidth: '94vw', maxHeight: '92vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 16px 0' }}>{editing ? `Düzenle: ${personel.ad_soyad}` : 'Yeni Personel'}</h3>

        {/* γ6 — Pasif personel badge + İşe Yeniden Al butonu */}
        {editing && personel && personel.aktif === false && (
          <div style={{
            background: '#ffebee',
            border: '1px solid #ef5350',
            borderRadius: radius.sm,
            padding: 12,
            marginBottom: 14,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <div style={{ fontSize: 12, color: '#c62828', fontWeight: 600 }}>
                ❌ İşten ayrılmış
                {personel.ise_cikis_tarihi && <> — {personel.ise_cikis_tarihi}</>}
                {personel.cikis_sebebi && (
                  <> | {(
                    {
                      ISVEREN_FESHI: 'İşveren Feshi',
                      ISTIFA: 'İstifa',
                      DENEME_FESHI: 'Deneme Feshi',
                      EMEKLILIK: 'Emeklilik',
                      ASKERLIK: 'Askerlik',
                      EVLILIK: 'Evlilik',
                      VEFAT: 'Vefat',
                      HAKLI_NEDEN: 'Haklı Neden',
                    }[personel.cikis_sebebi] || personel.cikis_sebebi
                  )}
                  {personel.cikis_sebebi_sgk_kodu && <> (Kod {personel.cikis_sebebi_sgk_kodu})</>}
                  </>
                )}
              </div>
              {!yenidenFormOpen && (
                <button
                  onClick={() => setYenidenFormOpen(true)}
                  style={{
                    padding: '6px 14px',
                    background: '#2e7d32',
                    color: 'white',
                    border: 'none',
                    borderRadius: radius.sm,
                    cursor: 'pointer',
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  ↻ İşe Yeniden Al
                </button>
              )}
            </div>

            {/* Inline dialog */}
            {yenidenFormOpen && (
              <div style={{
                marginTop: 10,
                padding: 12,
                background: 'white',
                border: `1px solid ${colors.border}`,
                borderRadius: radius.sm,
              }}>
                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, color: '#2e7d32' }}>
                  İşe Yeniden Al
                </div>
                <div>
                  <label style={{ ...hrLabel, marginBottom: 4 }}>
                    Yeni işe giriş tarihi (opsiyonel)
                  </label>
                  <input
                    type="date"
                    value={yenidenTarih}
                    onChange={e => setYenidenTarih(e.target.value)}
                    style={{ ...hrInput, width: '100%' }}
                  />
                  <div style={{ fontSize: 10, color: '#666', marginTop: 4, lineHeight: 1.5 }}>
                    Yeni tarih girerseniz <strong>kıdem sıfırlanır</strong> (yeni sözleşme).
                    Boş bırakırsanız eski tarih korunur (nadir durum — aynı sözleşmenin devamı).
                  </div>
                </div>
                <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                  <button
                    onClick={handleYenidenIseAl}
                    disabled={yenidenSaving}
                    style={{
                      padding: '8px 16px',
                      background: yenidenSaving ? '#aaa' : '#2e7d32',
                      color: 'white',
                      border: 'none',
                      borderRadius: radius.sm,
                      cursor: yenidenSaving ? 'not-allowed' : 'pointer',
                      fontWeight: 600,
                      fontSize: 12,
                    }}
                  >
                    {yenidenSaving ? 'İşleniyor...' : 'Onayla'}
                  </button>
                  <button
                    onClick={() => { setYenidenFormOpen(false); setYenidenTarih(''); }}
                    disabled={yenidenSaving}
                    style={{
                      padding: '8px 16px',
                      background: '#eee',
                      border: `1px solid ${colors.border}`,
                      borderRadius: radius.sm,
                      cursor: 'pointer',
                      fontSize: 12,
                    }}
                  >
                    İptal
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Tab bar */}
        <div style={{ ...hrTabBar, flexWrap: 'wrap' }}>
          {TABS.map(t => {
            const disabled = !editing && t.key !== 'temel';
            return (
              <button
                key={t.key}
                onClick={() => !disabled && setActiveTab(t.key)}
                disabled={disabled}
                style={{
                  ...hrTabBtn(activeTab === t.key),
                  opacity: disabled ? 0.4 : 1,
                  cursor: disabled ? 'not-allowed' : 'pointer',
                }}
                title={disabled ? 'Önce personeli kaydedin' : ''}
              >
                {t.label}
              </button>
            );
          })}
        </div>

        {/* Tab content */}
        {activeTab === 'temel' && renderTemelBilgiler()}
        {activeTab === 'belgeler' && renderBelgeler()}
        {activeTab === 'deneme' && renderDeneme()}
        {activeTab === 'maas' && renderMaas()}
        {activeTab === 'izinler' && renderIzinler()}
        {activeTab === 'disiplin' && renderDisiplin()}
        {activeTab === 'kidem' && renderKidem()}

        <div style={{ marginTop: 20, display: 'flex', gap: 8 }}>
          <button
            onClick={handleSave}
            disabled={saving}
            style={{ flex: 1, padding: 10, background: styles.success, color: 'white', border: 'none', borderRadius: radius.sm, cursor: saving ? 'not-allowed' : 'pointer', fontWeight: 600, opacity: saving ? 0.7 : 1 }}
          >
            {saving ? 'Kaydediliyor...' : (editing ? 'Güncelle' : 'Kaydet')}
          </button>
          <button
            onClick={onClose}
            style={{ flex: 1, padding: 10, background: '#666', color: 'white', border: 'none', borderRadius: radius.sm, cursor: 'pointer' }}
          >
            İptal
          </button>
        </div>
      </div>
    </div>
  );
};

export default PersonelModal;
